import { c as _c } from "react/compiler-runtime";
import { isPhosphorIconName } from '@/components/icons/PhosphorIcon/isPhosphorIconName';
import { cn } from '@/lib/cn';
type PhosphorIconProps = {
  className?: string;
  name?: string;
};
export function PhosphorIcon(t0) {
  const $ = _c(3);
  const {
    className,
    name
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== name) {
    const cleanName = name?.replace("jucy-icon", "").trim();
    t1 = isPhosphorIconName(cleanName) ? <i className={cn(`ph ph-${cleanName}`, className)} data-testid={cleanName} /> : null;
    $[0] = className;
    $[1] = name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}